import {DialogContent, Stack, Typography} from '@mui/material';
import {BaseDialog} from '@resurs-internal/mui';
import {useDialog, useTranslate} from 'hooks';
import React from 'react';
import digitalInvoiceImage from 'assets/images/digital-invoice.png';
import {useAlertDialog} from '../../../components';
import {useConsents} from '@resurs-internal/rb-app-api';

export const DigitalInvoiceNotificationDialog = () => {
  const translate = useTranslate();
  const alert = useAlertDialog();
  const dialog = useDialog('digital-invoice-notification');
  const consents = useConsents();
  const consent = consents.query.data?.consents?.find(
    (c) => c.externalId === 'Communication MyPages',
  );

  const onConfirm = async () => {
    if (consent) {
      await consents.update.mutateAsync({consent: consent, approve: true});
    }
    alert.success({
      title: translate('digital.invoice.notification.success.title'),
      subtitle: translate('digital.invoice.notification.success.subtitle'),
    });
    dialog.onClose();
  };

  return (
    <BaseDialog
      open={dialog.open}
      maxWidth={'sm'}
      image={digitalInvoiceImage}
      actions={[
        {
          title: translate('digital.invoice.notification.cancel'),
          onClick: dialog.onClose,
          color: 'secondary',
        },
        {
          title: translate('digital.invoice.notification.confirm'),
          onClick: onConfirm,
          color: 'primary',
        },
      ]}>
      <DialogContent>
        <Stack alignItems={'center'} gap={2}>
          <Typography typography={'h2'}>
            {translate('digital.invoice.notification.title')}
          </Typography>
          <Typography sx={{'white-space': 'pre-line'}} typography={'body1'}>
            {translate('digital.invoice.notification.subtitle')}
          </Typography>
        </Stack>
      </DialogContent>
    </BaseDialog>
  );
};
